import {UserTierTypes} from '@eCommerce/frontend-legacy-shared-library';

export const isUserTierDiamond = (tier: UserTierTypes | undefined) => {
  const {
    DIAMOND,
    DIAMOND_PLUS,
    DIAMOND_PLUS_LEGACY,
    DIAMOND_ELITE,
    DIAMOND_ELITE_LEGACY,
  } = UserTierTypes;
  return tier
    ? [
        DIAMOND,
        DIAMOND_PLUS,
        DIAMOND_PLUS_LEGACY,
        DIAMOND_ELITE,
        DIAMOND_ELITE_LEGACY,
      ].includes(tier)
    : false;
};

export const isUserTierSevenStars = (tier?: UserTierTypes) => {
  return tier === UserTierTypes.SEVEN_STARS;
};
